<template>
	<div class="loginMode">
		<div class="con">
			<div class="userPortrait">
				<img v-bind:src="userImg||'https://static.qxiu.com/h5/img/static/default2.png'" />
			</div>
			<div class="userName">{{userNick||''}}</div>
			<a class="btnLogin" v-if="wxLogin&&!isxiaoxiong" v-bind:href="'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbdf212b5475d03c2&redirect_uri=http%3a%2f%2flogin.m.qxiu.com%2fcgi%2flogin%2fcallback%3floginType%3dwechatGZH%26oemid%3D201'+hrefstr+'%26target%3dweblive%26toUrl%3d'+protocol+'%3a%2f%2fh5.qxiu.com&response_type=code&scope=snsapi_userinfo&state=STATE&connect_redirect=1#wechat_redirect'">微信登录</a>
			<a class="btnLogin" v-if="wxLogin&&isxiaoxiong" v-bind:href="'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbdf212b5475d03c2&redirect_uri=http%3a%2f%2flogin.m.qxiu.com%2fcgi%2flogin%2fdlcallback%3floginType%3dwechatGZHDL%26oemid%3D43'+hrefstr+'%26target%3dweblive%26toUrl%3d'+protocol+'%3a%2f%2fh5.qxiu.com&response_type=code&scope=snsapi_userinfo&state=STATE&connect_redirect=1#wechat_redirect'">微信登录</a>
			<div class="dividLine">
				<span></span>
				<p>{{wxLogin?'其他':''}}登录方式</p>
				<span></span>
			</div>
			<div class="loginEntry" v-if="!isxiaoxiong">
				<a v-bind:href="'https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=100717093&redirect_uri=http%3a%2f%2flogin.m.qxiu.com%2fcgi%2flogin%2fcallback%3fjumpUrl%3dhttp%3a%2f%2flogin.m.qxiu.com%2fcgi%2flogin%2fweblivelogin%26oemid%3D201'+hrefstr+'%26toUrl%3d'+protocol+'%3a%2f%2fh5.qxiu.com%2findex.html&scope=get_user_info'"><i class="iconfont qq">&#xe633;</i></a>
				<a v-if="isShowLogin" v-bind:href="'https://api.weibo.com/oauth2/authorize?client_id=1032315493&redirect_uri=http%3a%2f%2flogin.m.qxiu.com%2fcgi%2flogin%2fcallback%3floginType%3dweibo%26oemid%3d201'+hrefstr+'%26target%3dweblive%26toUrl%3d'+protocol+'%3a%2f%2fh5.qxiu.com&scope=&'"><i class="iconfont weibo">&#xe605;</i></a>
				<a v-if="isShowLogin" href="javascript:void(0)" v-on:click="phoneLogin"><i class="iconfont phone">&#xe6bb;</i></a>
			</div>
			<div class="loginEntry" v-if="isxiaoxiong">
				<a v-bind:href="'https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=101499693&redirect_uri=http%3a%2f%2flogin.m.qxiu.com%2fcgi%2flogin%2fdlcallback%3ftarget%3dweblive%26loginType%3dqqDL%26oemid%3d43'+hrefstr+'%26toUrl%3d'+protocol+'%3a%2f%2fh5.qxiu.com%2findex.html&scope=get_user_info'"><i class="iconfont qq">&#xe633;</i></a>
				<a v-if="isShowLogin" v-bind:href="'https://api.weibo.com/oauth2/authorize?client_id=1032315493&redirect_uri=http%3a%2f%2flogin.m.qxiu.com%2fcgi%2flogin%2fdlcallback%3ftarget%3dweblive%26loginType%3dweiboDL%26oemid%3d43'+hrefstr+'%26toUrl%3d'+protocol+'%3a%2f%2fh5.qxiu.com&scope=&'"><i class="iconfont weibo">&#xe605;</i></a>
				<a v-if="isShowLogin" href="javascript:void(0)" v-on:click="phoneLogin"><i class="iconfont phone">&#xe6bb;</i></a>
			</div>
			<p>登录即代表您同意
				<a href="https://client.qxiu.com/statement/privacy4.html">齐齐服务和隐私条款</a>
			</p>
		</div>
		<div class="cover" v-on:click="outPop"></div>
	</div>
</template>

<script>
	import cookie from '../../libs/cookie'
	import { mapState } from 'vuex'
	export default {
		name: 'index',
		data() {
			return {
				userImg: '',
				userNick: '',
				protocol: 'https'  //location.protocol.slice(0,-1)
			}
		},
		mounted() {
			if(cookie.get("loginType") == "wechatGZH") {
				this.userImg = cookie.get('photo')
				this.userNick = cookie.get('nick')
			}
		},
		computed:{
			isxiaoxiong(){
				return  cookie.get('isxiaoxiong')=='true'
			},
			hrefstr(){
				var hrefstr = '';

				if(this.sourceType){
					hrefstr += '%26sourceType%3D'+ this.sourceType;
				}
		
				if(this.channelID){
					hrefstr += '%26channelid%3D'+ this.channelID;
				}
				
				return hrefstr;
			},
			wxLogin(){
				return this.isWeixin()
			},
			isShowLogin(){
				return !(cookie.get('channelid') == 55 || cookie.get('channelid') == 10102);
			},
			...mapState(
				['channelID','sourceType','forceLogin']
			)
		},
		methods: {
			phoneLogin() {
				this.$store.commit('getCurview', 'phonelogin')
			},
			outPop() {
				if(!this.forceLogin){
					this.$store.commit('getCurview', '')
				}
			},
			isWeixin() {
				var ua = window.navigator.userAgent.toLowerCase();
				if(ua.match(/MicroMessenger/i) == 'micromessenger') {
					return true;
				} else {
					return false;
				}
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.loginMode {
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(0, 0, 0, .6);
		z-index: 200;
	}
	
	.con {
		position: absolute;
		width: 14.2rem;
		bottom: 0;
		left: 50%;
		margin-left: -7.5rem;
		padding: 1.6rem 0.4rem 0.4rem 0.4rem;
		background: #fff;
		text-align: center;
		border-top-left-radius: 0.6rem;
		border-top-right-radius: 0.6rem;
		z-index: 10;
	}
	
	.con .userPortrait{
		width: 3.5rem;
		height: 3.5rem;
		border-radius: 50%;
		position: absolute;
		top: -1.75rem;
		left: 50%;
		margin-left: -1.75rem;
		background: #fff;
	}
	.con .userPortrait img{
		width: 3.2rem;
		height: 3.2rem;
		margin-top: 0.15rem;
		border-radius: 50%;
	}
	
	.userName {
		font-size: 0.48rem;
		color: #666;
	}
	
	.dividLine {
		margin: 0.4rem 0 0.7rem;
		text-align: center;
	}
	
	.dividLine span {
		display: inline-block;
		width: 5rem;
		vertical-align: top;
		margin-top: 0.32rem;
		border-top: 1px solid #ccc;
	}
	
	.dividLine p {
		margin: 0 0.3rem;
		display: inline-block;
		font-size: 0.48rem;
		color: #999;
	}
	
	.loginEntry {
		text-align: center;
	}
	
	.loginEntry i {
		font-size: 1.36rem;
		margin: 0 1.2rem;
	}
	
	.loginEntry a {
		display: inline-block;
	}
	
	.qq {
		color: #1F9EFF;
	}
	
	.weibo {
		color: #FF4C4C;
	}
	
	.phone {
		color: #32DCD6;
	}
	
	.con>p {
		text-align: center;
		margin-top: 0.5rem;
		color: #ccc;
		font-size: 0.4rem;
	}
	
	.con>p a {
		color: #ccc;
		text-decoration: underline;
	}
	
	.btnLogin {
		display: block;
		width: 5.2rem;
		height: 1.6rem;
		background: #3CB035;
		border-radius: 0.8rem;
		text-align: center;
		font-size: 0.64rem;
		line-height: 1.6rem;
		color: #fff;
		margin: 0.4rem auto 0;
	}
	
	.cover {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
	}
</style>


// WEBPACK FOOTER //
// loginMode.vue?e96411c8